import { JsonObjectSchema, safeParseJson } from '@shared/parse-json';

// The admin SSE endpoints emit heterogeneous frames ({step,status}, {type,...}).
// Callers narrow per endpoint, so the only shared guarantee is "a JSON object".
export async function consumeSSE(
  resp: Response,
  onEvent: (event: Record<string, unknown>) => void,
): Promise<void> {
  const reader = resp.body!.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        const parsed = safeParseJson(JsonObjectSchema, line.slice(6));
        if (parsed.success) onEvent(parsed.data);
      }
    }
  }
}
